export default "__VITE_ASSET__0125b9c5__"